module.exports = __webpack_public_path__ + "media/fyt_m2.24eedadf.mp4";